import { render, staticRenderFns } from "./tickImg.vue?vue&type=template&id=3e4ea316&scoped=true&"
import script from "./tickImg.vue?vue&type=script&lang=js&"
export * from "./tickImg.vue?vue&type=script&lang=js&"
import style0 from "./tickImg.vue?vue&type=style&index=0&id=3e4ea316&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4ea316",
  null
  
)

export default component.exports